export const CLUSTER_X_ID = 0
export const CLUSTER_Y_ID = 999
